module.exports = __webpack_public_path__ + "static/angle-down.ad82171f8399438b89a7ca59ab13aadf.svg";